export default __webpack_public_path__ + "static/media/intro.dfab2ce5.jpg";